/**
 * SCP Size Guide Modal
 * Opens a modal with preloaded content from product metafield
 */

class SCPSizeGuideModal {
  constructor() {
    this.modal = document.querySelector("[data-scp-size-guide-modal]");
    this.overlay = document.querySelector("[data-scp-modal-overlay]");
    this.closeButton = document.querySelector("[data-scp-modal-close]");
    this.contentContainer = document.querySelector("[data-scp-modal-content]");
    this.titleElement = document.getElementById("scp-size-guide-modal-title");
    this.triggers = document.querySelectorAll("[data-scp-size-guide-trigger]");

    if (!this.modal) return;

    this.init();
  }

  init() {
    // Add click listeners to all size guide triggers
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        // Find the preloaded content script tag (sibling of the button)
        const contentScript = trigger.nextElementSibling;

        if (contentScript && contentScript.type === "application/json") {
          try {
            const data = JSON.parse(contentScript.textContent);
            this.open(data.title, data.content);
          } catch (error) {
            console.error("Error parsing size guide content:", error);
            this.showError();
          }
        } else {
          console.error("Size guide content not found");
          this.showError();
        }
      });
    });

    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.close();
      });
    }

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener("click", () => {
        this.close();
      });
    }

    // ESC key
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        this.modal.getAttribute("aria-hidden") === "false"
      ) {
        this.close();
      }
    });
  }

  open(title, content) {
    // Set title
    if (this.titleElement && title) {
      this.titleElement.textContent = title;
    }

    // Set content (already HTML from page.content)
    if (content) {
      this.contentContainer.innerHTML = content;
    } else {
      this.showError();
      return;
    }

    // Show modal
    this.modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  close() {
    this.modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  showError() {
    if (this.contentContainer) {
      this.contentContainer.innerHTML = `
        <div class="scp-size-guide-modal__error">
          <p>Unable to load size guide. Please try again.</p>
        </div>
      `;
    }
  }
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new SCPSizeGuideModal();
  });
} else {
  new SCPSizeGuideModal();
}

// Re-initialize on section load (for theme editor)
document.addEventListener("shopify:section:load", () => {
  new SCPSizeGuideModal();
});
